document.addEventListener("DOMContentLoaded", () => {
    const currentLocale = document.documentElement.lang || 'cs';

    if (typeof CookieConsent !== "undefined") {
        CookieConsent.run({
            categories: {
                necessary: {
                    enabled: true,
                    readOnly: true
                },
                analytics: {}
            },
            language: {
                default: currentLocale,
                translations: {
                    en: {
                        consentModal: {
                            title: 'We use cookies',
                            description: 'This website uses cookies to ensure the best user experience.',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            showPreferencesBtn: 'Manage Individual preferences'
                        },
                        preferencesModal: {
                            title: 'Manage cookie preferences',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            savePreferencesBtn: 'Accept current selection',
                            closeIconLabel: 'Close modal',
                            sections: [
                                {
                                    title: 'Cookie usage',
                                    description: 'Nomia uses cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/documents/Nomia_Cookies.pdf" target="_blank" class="cc-link">Cookie Policy</a>.'
                                },
                                {
                                    title: 'Strictly Necessary cookies',
                                    description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                                    linkedCategory: 'necessary'
                                },
                            ]
                        }
                    },
                    cs: {
                        consentModal: {
                            title: 'Používáme cookies!',
                            description: 'Tento web používá cookies k zajištění co nejlepšího uživatelského zážitku.',
                            acceptAllBtn: 'Přijmout vše',
                            acceptNecessaryBtn: 'Odmítnout vše',
                            showPreferencesBtn: 'Spravovat individuální preference'
                        },
                        preferencesModal: {
                            title: 'Správa předvoleb cookies',
                            acceptAllBtn: 'Přijmout vše',
                            acceptNecessaryBtn: 'Odmítnout vše',
                            savePreferencesBtn: 'Uložit aktuální výběr',
                            closeIconLabel: 'Zavřít okno',
                            sections: [
                                {
                                    title: 'Používání souborů cookie',
                                    description: 'Soubory cookie používám k zajištění základních funkcí webových stránek a ke zlepšení vašeho online zážitku. U každé kategorie si můžete zvolit, zda se chcete přihlásit nebo odhlásit, kdykoli budete chtít. Další podrobnosti týkající se souborů cookie a dalších citlivých údajů naleznete v úplném znění zde: <a href="/documents/Nomia_Cookies.pdf" target="_blank" class="cc-link">Zásady užívaní souboru cookies</a>.'
                                },
                                {
                                    title: 'Nezbytné cookies',
                                    description: 'Tyto cookies jsou vyžadovány pro správnou funkčnost našich webových stránek a v našem systému je nelze vypnout.',
                                    linkedCategory: 'necessary'
                                },
                            ]
                        }
                    }
                }
            }
        });

        document.querySelectorAll('[data-action="open-cookie-preferences"]').forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                if (window.CookieConsent && CookieConsent.showPreferences) {
                    CookieConsent.showPreferences();
                } else {
                    console.warn("CookieConsent is not initialized or showPreferences is unavailable.");
                }
            });
        });
    }
});